export const EDITABLE_KEYS = {
  title: 'title',
  email1: 'email1',
  email2: 'email2',
  phone1: 'phone1',
  phone2: 'phone2',
};

export const ADDABLE_KEYS = {
  phone: 'phone',
  email: 'email',
};

export const EMAIL_KEYS = [
  EDITABLE_KEYS.email1,
  EDITABLE_KEYS.email2,
];
